import { createGeneralSelectors } from '../_common/selectors';

const getProcessSlice = state => state.process;
export const { getById, getIds, makeGetByQuery } = createGeneralSelectors(getProcessSlice);
export const getProcess = (state, id) => state.processes.byId[id];
